import { getStudents, subjectsObjKey } from '../Common/Database';

export function getTeachersSubjects(mail: string) {
  const fetchStudentsListData = async () => {
    const studentsList = await getStudents();
    if (studentsList) {
      const mapList = Object.values(studentsList);

      const filteredMapList = mapList.filter(student => {
        if (student.subjects && Object.keys(student.subjects).length > 0) {
          for (const subjectKey in student.subjects) {
            const subject = student.subjects[subjectKey];
            if (subject.attachedTeacher && subject.attachedTeacher.id === mail) {
              return true;
            }
          }
        }
        return false;
      });

      return filteredMapList;
    }
  };

  return fetchStudentsListData().then(data => {
    const subjectsArr: string[] = [];

    data?.forEach(student => {
      const subj = student?.subjects;
      let proxySubjArr = [];

      if (subj) {
        const keys = Object.keys(subj);
        proxySubjArr = keys.map(key => subj[key]);

        proxySubjArr.forEach(proxySubject => {
          const name = subjectsObjKey[proxySubject.name];

          if (
            proxySubject &&
            proxySubject.activeSub &&
            !subjectsArr.includes(name) &&
            proxySubject?.attachedTeacher?.id &&
            proxySubject.attachedTeacher.id === mail
          ) {
            subjectsArr.push(name);
          }
        });
      }
    });

    return subjectsArr;
  });
}
